/**
 * Loads CSS from src/assets/CSS/<company identifier>/*.css
 * when it matches data.userDetails.company.identifier (same idea as company-specific components/mixins).
 * Root files under assets/CSS (style-main.css, etc.) are not loaded here.
 */
let companyCssLoadedIdentifier = null;

export function loadCompanyCSS() {
  try {
    const raw = localStorage.getItem("data");
    if (!raw) return;
    const data = JSON.parse(raw);
    const companyIdentifier = data?.userDetails?.company?.identifier ?? "";
    if (!companyIdentifier) return;
    if (companyCssLoadedIdentifier === companyIdentifier) return;

    const cssFiles = require.context("@/assets/CSS/", true, /\.css$/);
    const id = companyIdentifier;
    const lower = id.toLowerCase();
    const upper = id.toUpperCase();

    cssFiles.keys().forEach((fileName) => {
      const inCompanyFolder =
        fileName.includes(`/${id}/`) ||
        fileName.includes(`/${lower}/`) ||
        fileName.includes(`/${upper}/`);
      if (inCompanyFolder) {
        cssFiles(fileName);
      }
    });

    companyCssLoadedIdentifier = companyIdentifier;
  } catch (e) {
    console.warn("loadCompanyCSS:", e);
  }
}

/** Call on logout if you need the next login to re-apply the same company's CSS from scratch. */
export function resetCompanyCssLoadState() {
  companyCssLoadedIdentifier = null;
}
